<div class="main">

  <mat-card class="login-panel">
    <img mat-card-image src="assets/mitra-logo.svg" alt="Mitra Fiber">

    <form class="login-form" [formGroup]="loginForm" (submit)="login()" fxLayout="column">

      <mat-error *ngIf="error">
        {{error.message}}
      </mat-error>

      <mat-form-field appearance="outline">
        <input matInput formControlName="email" i18n-placeholder placeholder="E-MAIL">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <input matInput formControlName="password" type="password" i18n-placeholder placeholder="PASSWORD">
      </mat-form-field>

      <button mat-button [disabled]="loginForm.invalid" i18n>LOGIN</button>
    </form>

  </mat-card>

</div>
